import React, { useState, useEffect } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
// import companiesData from '../data/companies.json';
import Campaigns from "@/components/Companies/Campaigns";
import Campaign from "@/components/Companies/InterviewSlots";
import Vacancies from "@/components/Companies/Vacancies";
// import Candidates from '@/components/Companies/Candidates';
import Applications from "@/components/Companies/Applications";
import InterviewSlots from "@/components/Companies/InterviewSlots";
import InterviewSlotsList from "@/components/Interview/InterviewSlotsList";
import { useCompanyById } from "@/hooks/queries/useCompanies";
import Loader from "@/components/Loader";
// import CompanyForm from '@/components/Companies/CompanyForm';
import { default as CompanyForm } from "@/components/Companies/CompanyComponents/Form";
import useGlobalStore from "@/hooks/stores/useGlobalStore";
import DataLossWarningDialog from "../components/shared/DataLossWarningDialog";
import { ArrowLeft } from "lucide-react";
import PageHeader from "@/components/Common/PageHeader";

const CompanyView = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  // Use global store for active tab
  const { showDataLossWarning, setDataLossWarning, activeTab, setActiveTab } =
    useGlobalStore();

  const [campaignId, setCampaignId] = useState(
    location.state?.campaignId || null,
  );
  const [showWarningDialog, setShowWarningDialog] = useState(false);
  const [pendingTabChange, setPendingTabChange] = useState(null);
  const [pendingNavigation, setPendingNavigation] = useState(null);

  const { data: companyData, isLoading, isError } = useCompanyById(id);
  const company = companyData?.company;

  const tabs = [
    { id: "overview", label: "Overview" },
    { id: "campaigns", label: "Campaigns" },
    { id: "vacancies", label: "Vacancies" },

    // { id: 'candidates', label: 'Candidates' },
    { id: "applications", label: "Applications" },
    // { id: "interview_slots", label: "Interview Slots" },
    { id: "display_slots", label: "Interview Slots" },
    // { id: 'microsite', label: 'Microsite' },
  ];

  useEffect(() => {
    // console.log('Company data:', company);
  }, [company]);

  const handleTabChange = (tabId) => {
    if (showDataLossWarning) {
      setPendingTabChange(tabId);
      setPendingNavigation(null);
      setShowWarningDialog(true);
    } else {
      setActiveTab(tabId);
    }
  };

  const handleNavigation = (path) => {
    if (showDataLossWarning) {
      setPendingNavigation(path);
      setPendingTabChange(null);
      setShowWarningDialog(true);
    } else {
      navigate(path);
    }
  };

  const handleConfirmAction = () => {
    if (pendingTabChange) {
      setActiveTab(pendingTabChange);
      setDataLossWarning(false);
      setShowWarningDialog(false);
      setPendingTabChange(null);
    } else if (pendingNavigation) {
      navigate(pendingNavigation);
      setDataLossWarning(false);
      setShowWarningDialog(false);
      setPendingNavigation(null);
    }
  };

  const handleCancelAction = () => {
    setShowWarningDialog(false);
    setPendingTabChange(null);
    setPendingNavigation(null);
  };

  const renderTabContent = () => {
    switch (activeTab) {
      case "overview":
        return (
          <div className="w-full md:w-1/2">
            <CompanyForm hideHeader={true} companyId={id} />
          </div>
        );
      case "campaigns":
        return (
          <Campaigns
            setActiveTab={setActiveTab}
            setCampaignId={setCampaignId}
          />
        );
      case "vacancies":
        return (
          <Vacancies setActiveTab={setActiveTab} campaignId={campaignId} />
        );
      case "interview_slots":
        return <InterviewSlots setActiveTab={setActiveTab} />;
      case "display_slots":
        return (
          <InterviewSlotsList
            companyId={id}
            embedded
            showHeader={false}
            showCreateButton={false}
            requireVacancySelection
            paginationKey="display-slots-table"
          />
        );
      // case 'candidates':
      //   return <Candidates />;
      case "applications":
        return <Applications />;
      // case 'microsite':
      //   return <h2 className="text-xl font-medium">Microsite Content</h2>;
      default:
        return null;
    }
  };

  if (isLoading) {
    return <Loader />;
  }

  if (isError) {
    return <div className="p-6">Error loading company data.</div>;
  }

  return (
    <div className="p-6">
      <PageHeader
        heading={company.name}
        navigationText="Back to Companies"
        navigateTo="/companies"
      />
      <div className="bg-card rounded-lg shadow-md mt-6">
        <div className="border-b border-border">
          <nav className="flex">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => handleTabChange(tab.id)}
                className={`px-6 py-4 text-sm font-medium border-b-2 ${
                  activeTab === tab.id
                    ? "border-foreground text-foreground"
                    : "border-transparent text-muted-foreground hover:text-foreground hover:border-input"
                }`}
              >
                {tab.label}
              </button>
            ))}
          </nav>
        </div>

        <div className="p-6">{renderTabContent()}</div>
      </div>

      <DataLossWarningDialog
        isOpen={showWarningDialog}
        onCancel={handleCancelAction}
        onConfirm={handleConfirmAction}
      />
    </div>
  );
};

export default CompanyView;
